import "./styles/footer.css";
import hoppernfriends from "../images/temp_bottom_banner.png";

function Footer() {
  return (
    <>
      <div className="">
        <div className="container pt-2 text-center">
          <h3 className="text-white fs-6">
            Brought to you by the Stony Brook University - Women in Computer
            Science{" "}
          </h3>
        </div>
        {/* <img
          src={hoppernfriends}
          class="img-fluid"
          alt="Sponsor Image"
          style={{ maxWidth: "100%"}}
        /> */}
      </div>
    </>
  );
}

export default Footer;
